(ns frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.chart-data-editor
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.modal.edit-modals.common :as common-components]
   [frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.events :as events]
   [frontend.ui.component.lp-portal.modal.style :as style]
   [herb.core :as h]
   [ui.editors.data-input :as data-input]))

(defn table-numerical-body
  [state no-columns?]
  (let [series-data (:series @state)]
    (when-not no-columns?
      (into [:tbody]
            (->> series-data
                 (map-indexed
                  (fn [row-idx series-row]
                    (let [series-name (:series-name series-row)
                          row-data (vec (concat [series-name] (:data series-row)))]
                      (into [:tr]
                            (common-components/numerical-cells-row
                             {:state state
                              :row-idx row-idx
                              :row-data row-data
                              :update-value! events/update-series-data!}))))))))))

(defn data-editor-table
  [{:keys [state no-columns? fixed-columns? fixed-labels?]}]
  (if-not (every? (set (keys @state)) #{:y-axis-configs :series :columns})
    [:div
     (loc/tr :incorrect-chart-data [(pr-str (keys @state))])]
    [:div {:style {:display        "flex"
                   :gap            "20px"
                   :flex-direction "column"}}
     [:h1 (loc/tr :series-data)]
     [:div {:style {:display "flex"
                    :gap     "20px"}}
      [:table
       [common-components/table-header-row state
        {:no-columns?    no-columns?
         :fixed-labels?  fixed-labels?
         :fixed-columns? fixed-columns?
         :has-colors?    false
         :add-column-to-index! events/add-column-to-index-multi-chart!
         :remove-column! events/remove-column-multi-chart!}]
       [table-numerical-body state no-columns?]]]]))

(defn y-axis-editor-table-header-row
  []
  [:thead
   (into
    [:tr]
    (concat
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        (loc/tr :y-axis-title)]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        (loc/tr :decimal-amount)]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        (loc/tr :multiplier)]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        "Y-axis side"]]]))])

(defn table-axis-cells
  [state]
  [:table
   [y-axis-editor-table-header-row]
   (into [:tbody]
         (->> @state
              :y-axis-configs
              (map-indexed
               (fn [row-idx row]
                 (let [y-axis-title (:y-axis-title row)
                       y-axis-decimals (:y-axis-decimals row)
                       y-axis-multiplier (:y-axis-multiplier row)
                       y-axis-side (:y-axis-side row)]
                   [:tr
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/text-simple
                       :class     (h/<class style/table-header-input false)
                       :value     (str y-axis-title)
                       :on-change  (fn [value]
                                    (swap! state assoc-in [:y-axis-configs row-idx :y-axis-title] value))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type    :data.type/integer
                       :class        (h/join (h/<class style/number-input)
                                             (h/<class style/full-width))
                       :value        (abs y-axis-decimals)
                       :on-change     (fn [value]
                                       (swap! state assoc-in [:y-axis-configs row-idx :y-axis-decimals] (abs value)))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/ref-single
                       :class     (h/<class style/full-width)
                       :options   common-components/multiplier-options
                       :value     (->> common-components/multiplier-options
                                       (cu/filter-by :value y-axis-multiplier)
                                       (first))
                       :on-change (fn [value]
                                    (swap! state assoc-in [:y-axis-configs row-idx :y-axis-multiplier] value))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/ref-single
                       :class     (h/<class style/full-width)
                       :options   common-components/axis-side-options
                       :value     (->> common-components/axis-side-options
                                       (cu/filter-by :value y-axis-side)
                                       (first))
                       :on-change (fn [value]
                                    (swap! state assoc-in [:y-axis-configs row-idx :y-axis-side] value))}]]])))))])

(defn series-config-editor-header-row
  []
  [:thead
   (into
    [:tr]
    (concat
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        (loc/tr :series-name)]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        "Label decimal amount"]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        "Label multiplier"]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        "Tooltip decimal amount"]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        "Series color"]]]
     [[:th
       {:class (h/<class style/axis-table-th)}
       [:span
        {:class (h/<class style/title)}
        "Graph type"]]]))])

(defn table-tooltip-cells
  [state]
  [:table
   [series-config-editor-header-row]
   (into [:tbody]
         (->> @state
              :series
              (map-indexed
               (fn [row-idx series]
                 (let [series-name (:series-name series)
                       label-decimals (:label-decimals series)
                       label-multiplier (:label-multiplier series)
                       tooltip-decimals (:tooltip-decimals series)
                       series-color (:color-code series)
                       graph-type (:graph-type series)]
                   [:tr
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/text-simple
                       :class     (h/<class style/table-header-input false)
                       :value     (str series-name)
                       :on-change  (fn [value]
                                    (swap! state assoc-in [:series row-idx :series-name] value))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type    :data.type/integer
                       :class        (h/join (h/<class style/number-input)
                                             (h/<class style/full-width))
                       :value        label-decimals
                       :on-change     (fn [value]
                                       (swap! state assoc-in [:series row-idx :label-decimals] (abs value)))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/ref-single
                       :class     (h/<class style/full-width)
                       :options   common-components/multiplier-options
                       :value     (->> common-components/multiplier-options
                                       (cu/filter-by :value label-multiplier)
                                       (first))
                       :on-change (fn [value]
                                    (swap! state assoc-in [:series row-idx :label-multiplier] value))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type    :data.type/integer
                       :class        (h/join (h/<class style/number-input)
                                             (h/<class style/full-width))
                       :value        tooltip-decimals
                       :on-change     (fn [value]
                                       (swap! state assoc-in [:series row-idx :tooltip-decimals] (abs value)))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/text-simple
                       :class     (h/<class style/table-header-input false)
                       :value     (str series-color)
                       :on-change  (fn [value]
                                    (swap! state assoc-in [:series row-idx :color-code] value))}]]
                    [:td
                     {:class (h/<class style/axis-table-cell)}
                     [data-input/view
                      {:data-type :data.type/ref-single
                       :class     (h/<class style/full-width)
                       :options   common-components/graph-type-options
                       :value     (->> common-components/graph-type-options
                                       (cu/filter-by :value graph-type)
                                       (first))
                       :on-change (fn [value]
                                    (swap! state assoc-in [:series row-idx :graph-type] value))}]]])))))])
